class BigAccordion {
	constructor(accordion) {
		this.accordion = accordion;
		this.expandButtons = Array.from(accordion.querySelectorAll('.js-big-accordion-cta'));

		this.toggleAccordion = this.toggleAccordion.bind(this);
		this.setUp = this.setUp.bind(this);
		this.urlContainsLinkToChild = this.urlContainsLinkToChild.bind(this);
		this.setUp();
	}

	toggleAccordion() {
		this.accordion.classList.toggle('is-open');
	}

	setUp() {
		this.expandButtons.forEach(btn => {
			btn.addEventListener('click', this.toggleAccordion);
		});

		if (this.urlContainsLinkToChild()) this.toggleAccordion();
	}

	urlContainsLinkToChild() {
		return window.location.hash && this.accordion.querySelector(window.location.hash)
			? true
			: false;
	}
}

Array.from(document.querySelectorAll('.js-big-accordion')).forEach(accordion => {
	new BigAccordion(accordion);
});
